// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"304df09b","88":"f5996182","153":"345671f1","704":"08d49eab","755":"769f8547","774":"6415c182","805":"9041e8b7","868":"84f9ff08","941":"97a59715"}[chunkId] + ".chunk.js";
};